module.exports = __webpack_public_path__ + "img/calendar-active.6386a2ef.svg";